export var BLOK_YOUTUBE = "YoutubeVideo";
export var isYoutubeBlok = function(props) {
    return Object.prototype.hasOwnProperty.call(props, "videoId") && Object.prototype.hasOwnProperty.call(props, "title") && Object.prototype.hasOwnProperty.call(props, "buttonLabel");
};
